import Vue from 'vue'
import VueRouter from 'vue-router'
import until from '@/api/until.js'
import studioApi from '@/api/teaching_studio_teaching_studio_api.js'
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import( '../views/Home.vue'),
		
	},
	{
		path: '/login',
		name: 'login',
		component: () => import( '../views/Login.vue'),
		meta: { public: true },
	},
	{
		path: '/register',
		name: 'register',
		component: () => import('../views/Register.vue'),
		meta: { public: true },
	},
	{
		path: '/sale_service',
		name: 'sale_service',
		component: () => import('../views/SaleService.vue'),
		meta: { public: true },
	},
	{
		path: '/after-sales/mobile',
		name: 'after-sales-mobile',
		component: () => import('../views/AfterSalesMobile.vue'),
		meta: { requiresAfterSales: true },
	},
	{
		path: '/after-sales/workflow',
		name: 'after-sales-workflow',
		component: () => import('../views/AfterSalesWorkflowMobile.vue'),
		meta: { requiresAfterSales: true },
	},
	{
		path: '/after-sales/orders',
		name: 'after-sales-orders',
		component: () => import('../views/AfterSalesOrdersMobile.vue'),
		meta: { requiresAfterSales: true },
	},
	{
		// requiresInternal：只对内部人员开放，判定与底部菜单「工作台」用的是同一把尺子
		// （超管 或 is_iotmax=1）。外部人员就算手敲这个地址也会被送回「我的」。
		path: '/internal/workbench',
		name: 'internal-workbench',
		component: () => import('../views/InternalWorkbench.vue'),
		meta: { requiresInternal: true },
	},
	{
		path: '/room',
		name: 'Room',
		component: () => import( '../views/Room.vue'),
		
	},
	{
		path: '/data',
		name: 'Data',
		component: () => import( '../views/Data.vue'),
		
	},
	{
		path: '/addwarning',
		name: 'AddWarning',
		component: () => import( '../views/addWarning.vue'),
		
	},
	{
		path: '/editwarning',
		name: 'EditWarning',
		component: () => import( '../views/editWarning.vue'),
		
	},
	{
		path: '/mine',
		name: 'Mine',
		component: () => import( '../views/Mine.vue'),
		
	},
	{
		path: '/edituser',
		name: 'edituser',
		component: () => import( '../views/editUser.vue'),
		
	},
	{
		path: '/userlist',
		name: 'userlist',
		component: () => import( '../views/UserList.vue'),
		meta: { requiresHost: true },
	},
	{
		path: '/usercode',
		name: 'usercode',
		component: () => import( '../views/UserCode.vue'),
		meta: { requiresHost: true },
	},
	{
		path: '/adduser',
		name: 'adduser',
		component: () => import( '../views/addUser.vue'),
		meta: { requiresHost: true },
	},
	{
		path: '/addshortselect',
		name: 'addshortselect',
		component: () => import( '../views/addShortSelect.vue'),
		
	},
	{
		path: '/swim',
		name: 'swim',
		component: () => import( '../views/Swim.vue'),
		
	},
	{
		path: '/devicelist',
		name: 'devicelist',
		component: () => import( '../views/deviceList.vue'),
		
	},
	// ============== 仓库管理路由 ==============
	{
		path: '/warehouse',
		name: 'warehouse',
		component: () => import( '../views/WarehouseManage.vue'),
	},
	// 设备详情
	{
		path: '/warehouse/device/detail',
		name: 'devicestockdetail',
		component: () => import( '../views/DeviceStockDetail.vue'),
		meta: { public: true },
	},
	// 产品列表
	{
		path: '/warehouse/product',
		name: 'productlist',
		component: () => import( '../views/ProductList.vue'),
	},
	// 物料列表
	{
		path: '/warehouse/material',
		name: 'materiallist',
		component: () => import( '../views/MaterialList.vue'),
		meta: { requiresMaterial: true },
	},
	// 出入库记录
	{
		path: '/warehouse/record',
		name: 'stockrecord',
		component: () => import( '../views/StockRecord.vue'),
	},
	// 出入库记录详情
	{
		path: '/warehouse/record/detail',
		name: 'stockrecorddetail',
		component: () => import( '../views/StockRecordDetail.vue'),
	},
	// 发货记录
	{
		path: '/warehouse/shipment',
		name: 'shipmentrecord',
		component: () => import( '../views/ShipmentRecord.vue'),
	},
	// 发货记录详情
	{
		path: '/warehouse/shipment/detail',
		name: 'shipmentrecorddetail',
		component: () => import( '../views/ShipmentRecordDetail.vue'),
	},
	// 新增发货
	{
		path: '/warehouse/shipment/add',
		name: 'shipmentadd',
		component: () => import( '../views/ShipmentAdd.vue'),
	},
	// 详情页
	{
		path: '/warehouse/detail',
		name: 'stockdetail',
		component: () => import( '../views/StockDetail.vue'),
	},
	// 标签打印
	{
		path: '/warehouse/print',
		name: 'stockprint',
		component: () => import( '../views/StockPrint.vue'),
	},
	// 兼容旧路径
	{
		path: '/stockmanage',
		redirect: '/warehouse'
	},
	{
		path: '/stockdetail',
		redirect: '/warehouse/detail'
	},
	{
		path: '/stockrecord',
		redirect: '/warehouse/record'
	},
	{
		path: '/stockprint',
		redirect: '/warehouse/print'
	},


]
const router = new VueRouter({
	base: process.env.BASE_URL,
	routes
})

const defaultAppId = 'wx0154d46e98975549'
let userInfoRequest = null

function currentAppId() {
	return (router.app && router.app.$root && router.app.$root.app_id) || until.getParameter('app_id') || defaultAppId
}

/**
 * 是否内部人员。底部菜单（footer.vue）用的是同一条规则，改这里必须同步改那里，
 * 否则会出现「菜单里有工作台、点进去被弹回我的」。
 */
function isInternalUser(userInfo) {
	return Number(userInfo && userInfo.is_iotmax) === 1
}

async function loadIsSuper() {
	try {
		const res = await studioApi.Teaching_studio_apiUserIs_superGet({ app_id: currentAppId() })
		return !!(res && res.errcode === 0 && res.other === 'yes')
	} catch (e) {
		return false
	}
}

async function loadCurrentUserInfo() {
	if (!userInfoRequest) {
		userInfoRequest = studioApi.Teaching_studio_apiMemberLogin_userGet({ app_id: currentAppId() })
			.then(res => {
				if (!res || res.errcode !== 0 || !res.other) throw new Error((res && res.errmsg) || '无法获取当前用户权限')
				return res.other
			})
			.finally(() => {
				userInfoRequest = null
			})
	}
	return userInfoRequest
}

router.beforeEach(async (to, from, next) => {
	if (to.matched.some(record => record.meta.public)) {
		next()
		return
	}

	if (!until.getCookie('jwt_token')) {
		next({ path: '/login', query: { redirect: to.fullPath } })
		return
	}

	const requiresHost = to.matched.some(record => record.meta.requiresHost)
	const requiresMaterial = to.matched.some(record => record.meta.requiresMaterial) ||
		(to.path === '/warehouse/detail' && to.query.type === 'material')
	const requiresInternal = to.matched.some(record => record.meta.requiresInternal)
	if (!requiresHost && !requiresMaterial && !requiresInternal) {
		next()
		return
	}

	try {
		const userInfo = await loadCurrentUserInfo()
		if (router.app && router.app.$root) router.app.$root.userInfo = userInfo
		to.meta.currentUser = userInfo
		if (requiresHost && userInfo.studio_role !== 'host') {
			next({ path: '/mine', replace: true })
			return
		}
		if (requiresMaterial && Number(userInfo.stock_user_view_power) === 1) {
			next({ path: '/warehouse/product', replace: true })
			return
		}
		if (requiresInternal && !isInternalUser(userInfo)) {
			// is_iotmax 不是 1 还要再问一次超管接口：超管不一定带 is_iotmax 标记
			if (await loadIsSuper()) {
				if (router.app && router.app.$root) router.app.$root.isSuperRoot = true
				next()
				return
			}
			next({ path: '/mine', replace: true })
			return
		}
		next()
	} catch (e) {
		next({ path: '/login', query: { redirect: to.fullPath } })
	}
})

export default router
